// Imports ------------------------------------------------------------------->

import {Service, service, inject} from "./di";
import {ConfigService, RuntimeConfig} from "./ConfigService";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

@service
export class UserAgentService extends Service {

	@inject config: ConfigService;

	android = /Android/.test(navigator.userAgent);
	iOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
	ie = /MSIE|Trident/.test(navigator.userAgent);
	firefox = /Firefox|FxiOS/.test(navigator.userAgent);
	chrome = /Chrome|CriOS/.test(navigator.userAgent);

	get mobile() {
		return this.android || this.iOS ||
				// Firefox OS
				(this.firefox && /Mobile|Tablet|TV/.test(navigator.userAgent));
	}

	get safari() {
		return /Safari/.test(navigator.userAgent) &&
					// Firefox & Chrome on iOS report Safari, since they use UIWebView
					!this.firefox && !this.chrome;
	}

	getAppLinkHref(sourcePageName: string, source: string = "mweb") {

		const appLink = "https://flipp.app.link/KYJFGWvFo1";
		if (this.config.RUNTIME === RuntimeConfig.DISTRIBUTION) {
			return appLink;
		}

		if (this.android) {
				return this.getAndroidAppLink(sourcePageName, source);
		} else if (this.iOS) {
				return this.iosAppLink();
		} else {
				return appLink;
		}
	}

	iosAppLink(source: string = "FW Mobile") {
		return `https://itunes.apple.com/app/apple-store/id725097967?pt=694753&ct=${encodeURIComponent(source)}&mt=8`;
	}

	getAndroidAppLink(sourcePageName: string, source: string = "mweb") {
		return `https://play.google.com/store/apps/details?id=com.wishabi.flipp&hl=en&referrer=utm_source%3D${encodeURIComponent(source)}%26utm_campaign%3D${encodeURIComponent(sourcePageName)}`;
	}
}
